import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ContactForm from './ContactForm.jsx'; // Correct path (same folder)
import SEO from '../components/SEO.jsx';
import PageHero from './page/PageHero.jsx';

// `?intent=` (set by the homepage and navigation CTAs) only changes the
// visible heading. The form fields and submitted payload are unchanged.
const INTENT_COPY = {
  project: {
    heading: 'Discuss Your Project',
    lead: 'Tell us about your business and what you want your digital presence to achieve. We will be in touch to talk through next steps.',
  },
  quote: {
    heading: 'Request a Quote',
    lead: 'Share the details of your project below. We will review your requirements and prepare a tailored quote.',
  },
  review: {
    heading: 'Request Your Free Website Review',
    lead: "Tell us about your current website and what you'd like to improve. We'll take a look and discuss whether targeted changes or a full redesign would make the most sense.",
  },
  chatbot: {
    heading: 'Discuss an AI Chatbot',
    lead: 'Tell us about your website, the questions customers ask most and the systems you use. We will talk through what a chatbot could realistically handle for your business.',
  },
};

const DEFAULT_COPY = {
  heading: "Let's talk about your business",
  lead: 'Whether you need a new website, stronger search and AI visibility, Google Ads, an AI chatbot or ongoing support, tell us where you are now and where you want to be.',
};

export default function Contact() {
  const [searchParams] = useSearchParams();
  const copy = INTENT_COPY[searchParams.get('intent')] || DEFAULT_COPY;

  return (
    <div className="min-h-screen bg-brand-bg">
      <SEO
        title="Contact 2merative | Web Design, SEO & Google Ads Adelaide"
        description="Talk to 2merative about premium website development, SEO, Google Ads and ongoing digital support for your business, in Adelaide and beyond."
        path="/contact"
        image="/og-image.png"
      />

      <PageHero eyebrow="Contact" title={copy.heading} lead={copy.lead} showCtas={false} />

      <div className="px-4 pb-20 pt-2">
        <ContactForm />
      </div>
    </div>
  );
}
